export default __webpack_public_path__ + "static/media/mlr-2-rMIN.4e9f109b.avif";